import { useState } from 'react'
import { useLang } from '../i18n'
import { DataManagementPage } from './DataManagementPage'
import { QuarterlyReportPage } from './QuarterlyReportPage'

type DataReportsTab = 'data' | 'quarterly'

const DATA_REPORTS_TABS: DataReportsTab[] = ['data', 'quarterly']

const TAB_KEY_MAP: Record<DataReportsTab, string> = {
  data: 'dataReportsHubTabDataMgmt',
  quarterly: 'dataReportsHubTabQuarterly',
}

export function DataReportsHubPage() {
  const { t } = useLang()
  const [activeTab, setActiveTab] = useState<DataReportsTab>('data')

  return (
    <div data-testid="data-reports-hub-page">
      <div
        data-testid="data-reports-hub-tabs"
        style={{
          display: 'flex',
          gap: '4px',
          marginBottom: '24px',
          borderBottom: '2px solid var(--border, #e5e7eb)',
        }}
      >
        {DATA_REPORTS_TABS.map((tab) => (
          <button
            key={tab}
            data-testid={`data-reports-tab-${tab}`}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '8px 16px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === tab ? 600 : 400,
              color: activeTab === tab ? 'var(--accent, #2563eb)' : 'inherit',
              borderBottom: activeTab === tab ? '2px solid var(--accent, #2563eb)' : '2px solid transparent',
              marginBottom: '-2px',
            }}
          >
            {t(TAB_KEY_MAP[tab])}
          </button>
        ))}
      </div>
      <div data-testid="data-reports-hub-content">
        {activeTab === 'data' && <DataManagementPage />}
        {activeTab === 'quarterly' && <QuarterlyReportPage />}
      </div>
    </div>
  )
}
